import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Locatedoctor from '../../component/Locatedoctor'
// import { Map, GoogleApiWrapper } from 'google-maps-react';
import { BrowserRouter as Router, Switch, Route, HashRouter } from "react-router-dom"
import {
    Container, Row, Col
} from "reactstrap"
import Header from "../../component/Header";
import {
    FullWrap, Heading, SubHeading, MapWrap, InnerWrap,
    ResultWrap, ResultHeading, ResultCard, CardTopWrap, CardLink, CardInnerHeading, CardFooter,
    CallButton, VisitButton, MarkWrap, MapFirstName,
     MapPhoneNumber, MapUrl, MarkFooter, FooterRightWrap, FooterLeftWrap,MapFullWrap
} from "./styles";
import Footer from "../../component/Footer";
import GoogleMapReact from 'google-map-react';
import { getDoctorLocation } from '../../doctorapi'
import { toast } from "react-toastify"
import { FaShareAlt } from "react-icons/fa"
import { FiPrinter } from "react-icons/fi";
import get from 'lodash/get'

// const AnyReactComponent = ({ text }) => <div>{text}</div>;
const Maplist = ({ isCheckData, mapListingValues, center, zoom ,handleMouseOver ,handleMouseExit }) => {

    return (
        <div>
            {isCheckData ? (
                <MapWrap>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: 'AIzaSyBFTEG2DxMcjMh8FUt3lRdXyQ85wJrJj0c' }}
                        center={center}
                        zoom={zoom}
                    >
                        {mapListingValues &&
                            mapListingValues &&
                            mapListingValues.map((place, index) => {
                                return (

                                    <Marker
                                        key={index}
                                        firstname={place.firstName}
                                        lastName={place.lastName}
                                        centerName={place.centerName}
                                        address={place.Address}
                                        phone={place.phone}
                                        websiteURL={place.websiteURL}
                                        zip ={place.zip}
                                        distance={Number(place.distance) / 1609}
                                        lat={Number(place.latLong[1])}
                                        lng={Number(place.latLong[0])}
                                        color="red"
                                    />
                                )
                            }
                            )
                        }
                    </GoogleMapReact>
                </MapWrap>
            ) : (
                    <MapWrap>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: 'AIzaSyBFTEG2DxMcjMh8FUt3lRdXyQ85wJrJj0c' }}
                            defaultCenter={{ lat: 30, lng: -70 }}
                            zoom={zoom}
                        >
                            <Marker
                                color="none"
                            />
                        </GoogleMapReact>
                    </MapWrap>
                )}
            {/* {isCheckData ? (
                <ResultWrap>{isCheckData ? (
                    <ResultHeading>Result ({mapListingValues.length})</ResultHeading>) : (
                        <ResultHeading>No result</ResultHeading>
                    )}
                    {mapListingValues && mapListingValues.length && mapListingValues.map(places => {
                        return (
                            <ResultCard>
                                <CardTopWrap>
                                    <Row>
                                        <Col lg="4">
                                            <CardInnerHeading style={{ fontWeight: "700" }}>Full Name</CardInnerHeading>
                                            <CardInnerHeading>{"Dr. "+ places.firstName.concat(" " + places.lastName)}</CardInnerHeading>
                                        </Col>
                                        <Col lg="4">
                                            <CardInnerHeading style={{ fontWeight: "700" }}>Practice Name</CardInnerHeading>
                                            <CardInnerHeading>{places.centerName}</CardInnerHeading>
                                        </Col>
                                        <Col lg="4">
                                            <CardInnerHeading style={{ fontWeight: "700" }}>Address</CardInnerHeading>
                                            <CardInnerHeading>{(places.Address.concat(" "+places.zip))}</CardInnerHeading>
                                        </Col>
                                    </Row>
                                </CardTopWrap>
                                <CardFooter>
                                    <Row>

                                        <Col md="6" lg="4">
                                            <CardInnerHeading style={{ fontWeight: "700" }}>Phone Number</CardInnerHeading>
                                            <CardInnerHeading>{places.phone}</CardInnerHeading>
                                        </Col>
                                        <Col xs="6" lg="4">
                                            <CardInnerHeading style={{ fontWeight: "700" }}>Website</CardInnerHeading>
                                            <a href={"http://" + places.websiteURL}>{places.websiteURL}</a>
                                        </Col>
                                        <Col xs="6" lg="4">
                                            <CardInnerHeading style={{ fontWeight: "700" }}>Distance (in miles)</CardInnerHeading>
                                            <CardInnerHeading>{((places.distance) / 1609).toFixed(2)} Miles</CardInnerHeading>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </ResultCard>
                        )
                    })}
                </ResultWrap>) : (<p>
                    NO Result
                        </p>)} */}
        </div>
    )
}

export default Maplist

const Wrapper = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50% 50% 50% 0;
  background: #ea4335;
  position: absolute;
  transform: rotate(-45deg);
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
  cursor: pointer;
  &::after {
    content: "";
    width: 14px;
    height: 14px;
    margin: 8px 0 0 8px;
    background: #e6e6e6;
    position: absolute;
    border-radius: 50%;
  }

  animation-name: bounce;
  animation-fill-mode: both;
  animation-duration: 1s;

  @keyframes bounce {
    0% {
      opacity: 0;
      transform: translateY(-2000px) rotate(-45deg);
    }

    60% {
      opacity: 1;
      transform: translateY(30px) rotate(-45deg);
    }

    80% {
      transform: translateY(-10px) rotate(-45deg);
    }

    100% {
      transform: translateY(0) rotate(-45deg);
    }
  }
`

const PulseEffect = styled.div`
   {
    background: #d6d4d4;
    border-radius: 50%;
    height: 14px;
    width: 14px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: 11px 0px 0px -12px;
    transform: rotateX(55deg);
    z-index: -2;
  }
  &::after {
    content: "";
    border-radius: 50%;
    height: 40px;
    width: 40px;
    position: absolute;
    margin: -13px 0 0 -13px;
    animation: pulsate 1s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
    box-shadow: 0 0 1px 2px #ea4335;
    animation-delay: 1.1s;
  }
  @keyframes pulsate {
    0% {
      transform: scale(0.1, 0.1);
      opacity: 0;
    }

    50% {
      opacity: 1;
    }

    100% {
      transform: scale(1.2, 1.2);
      opacity: 0;
    }
  }
`

const Text = styled.p`
  font-size: 14px;
  font-style: bold;
  color: #686d6b;
  margin-left: 20px;
`

const Marker = props => {
    return (
        <MapFullWrap>
            <Wrapper
                className="pin bounce"
                alt={props}
                {...(props.onClick ? { onClick: props.onClick } : {})}

            />
            {props.firstname || props.address || props.centerName || props.phone || props.websiteURL || props.distance ? (
                <MarkWrap className="map-wrap">
                    {props.firstname ? (<MapPhoneNumber className="name">Name: {`Dr. ${get(props, 'firstname', '')} ${get(props,'lastName', '')}`}</MapPhoneNumber>) : (null)}
                    {props.centerName ? (<MapPhoneNumber>Practice Name: {props.centerName}</MapPhoneNumber>) : (null)}
                    {props.address ? (<MapPhoneNumber className="Address">Address: {`${get(props,'address', '')} - ${get(props, 'zip', '')}`}</MapPhoneNumber>) : (null)}
                    {props.phone ? (<MapPhoneNumber>Phone: {props.phone}</MapPhoneNumber>) : (null)}
                    {props.websiteURL ? (<MapUrl>Website: {props.websiteURL}</MapUrl>) : (null)}
                    {/* {props.distance ? (<MapPhoneNumber>Distance : {props.distance + "miles"}</MapPhoneNumber>) : (null)} */}
                    <MarkFooter>
                        <FooterLeftWrap>
                        </FooterLeftWrap>
                        <FooterRightWrap>
                            {/* <FaShareAlt />
                            <FiPrinter /> */}
                        </FooterRightWrap>
                    </MarkFooter>
                </MarkWrap>) : (null)}
            <PulseEffect />
        </MapFullWrap>
    )
}
Marker.defaultProps = {
    onClick: null
}

Marker.propTypes = {
    onClick: PropTypes.func,
    // text: PropTypes.string.isRequired
}





// WEBPACK FOOTER //
// ./src/component/Map/index.js